import { createStyles, type WithStyles, withStyles } from "@material-ui/core";
import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined";
import { useTranslations } from "adapters/i18n";
import { PortalRoutes } from "constants/routes";
import history from "features/app/History";
import ConfirmationModal from "features/shared/components/confirmationModal";
import React from "react";

export type PendingMovementsModalProps = {
  onClose: () => void;
} & WithStyles<typeof styles>;

const PendingMovementsModal = ({
  classes,
  onClose,
}: PendingMovementsModalProps) => {
  const { t } = useTranslations();

  const navigateToPendingMovements = () => {
    history.push(PortalRoutes.PENDING_MOVEMENTS);
    onClose();
  };

  return (
    <ConfirmationModal
      cancelButtonTitle={t("common:actions.close")}
      onCancel={onClose}
      onClose={onClose}
      onSubmit={navigateToPendingMovements}
      submitButtonTitle={t("pendency:view-pendencies")}
      text={<span>{t("pendency:pending-movements-needs-fix")}</span>}
      title={
        <span className={classes.title}>
          <WarningAmberOutlined color="error" />
          {t("pendency:pending-movements")}
        </span>
      }
    />
  );
};

const styles = () =>
  createStyles({
    title: {
      display: "flex",
      gap: "10px",
    },
  });

export default withStyles(styles)(PendingMovementsModal);
